import React from "react";
import Logo from "../assets/logos/oakman-logo.png";
import { Heart } from "lucide-react";

const FarewellPage = () => {
  return (
    <div className="min-h-screen flex flex-col sm:items-center sm:justify-center bg-gradient-to-r from-primary/100 to-secondary/20">
      <div className="max-w-2xl sm:mx-auto mx-3 sm:px-8 px-4 py-10 sm:py-12 bg-white rounded-lg shadow-[0_8px_30px_rgba(0,0,0,0.05)] border border-gray-100 sm:my-0 mt-16">
        <div className="flex justify-center mb-4">
          <img src={Logo} alt="Oakman Logo" className="w-64 h-auto" />
        </div>
        <div className="text-center">
          <h1 className="text-3xl font-bold text-logo mb-6">
            Cerramos la web,&nbsp;
            <br className="inline sm:hidden" />
            no la historia.
          </h1>
          <div className="mb-10">
            <p className="text-xl text-gray-700 mb-4">
              Este proyecto termina en su mejor momento, porque a veces evolucionar implica tener que decir adiós.
            </p>
            <p className="text-xl text-gray-700 font-semibold">¡Gracias por haber sido parte de algo tan especial!</p>
          </div>
          <div className="mt-5 pt-3 border-t border-gray-100 text-center">
            <div className="flex justify-center mb-1">
              <Heart className="text-red-400 w-8 h-auto" />
            </div>
            <p className="text-gray-500 text-sm">Con cariño, el equipo de OAKMAN</p>
            <a href="mailto:contacto@oakmanvs.com" className="text-xs text-secondary font-semibold">
              Si tienes curiosidad...
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarewellPage;